import { categoryService } from '@/services/category.service';
import { useQuery } from '@tanstack/react-query';

/**
 * Hook to fetch all categories
 */
export const useCategories = (limit?: number) => {
  return useQuery({
    queryKey: ['categories', limit],
    queryFn: () => categoryService.getCategories(limit),
    staleTime: 10 * 60 * 1000, // 10 minutes (categories don't change often)
  });
};

/**
 * Hook to fetch a single category by ID
 */
export const useCategory = (categoryId: string | undefined) => {
  return useQuery({
    queryKey: ['category', categoryId],
    queryFn: () => categoryService.getCategoryById(categoryId!),
    enabled: !!categoryId,
    staleTime: 10 * 60 * 1000,
  });
};

/**
 * Hook to fetch category by slug
 */
export const useCategoryBySlug = (slug: string | undefined) => {
  return useQuery({
    queryKey: ['category', 'slug', slug],
    queryFn: () => categoryService.getCategoryBySlug(slug!),
    enabled: !!slug,
    staleTime: 10 * 60 * 1000,
  });
};

/**
 * Hook to fetch parent categories (top-level)
 */
export const useParentCategories = () => {
  return useQuery({
    queryKey: ['categories', 'parent'],
    queryFn: () => categoryService.getParentCategories(),
    staleTime: 10 * 60 * 1000,
  });
};

/**
 * Hook to fetch subcategories
 */
export const useSubcategories = (parentId: string | undefined) => {
  return useQuery({
    queryKey: ['categories', 'subcategories', parentId],
    queryFn: () => categoryService.getSubcategories(parentId!),
    enabled: !!parentId,
    staleTime: 10 * 60 * 1000,
  });
};
